"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var react_autosuggest_1 = __importDefault(require("react-autosuggest"));
var react_isolated_scroll_1 = __importDefault(require("react-isolated-scroll"));
// the key for the suggestion, we're returning specValue directly so no need to access property
var getSuggestionValue = function (suggestion) { return suggestion; };
var renderSuggestion = function (suggestion) { return react_1.default.createElement("div", null, suggestion); };
var CLEAR_SELECTION = '選択解除';
var SellerGroupModelListFilter = /** @class */ (function (_super) {
    __extends(SellerGroupModelListFilter, _super);
    function SellerGroupModelListFilter(props) {
        var _this = _super.call(this, props) || this;
        _this.shouldRenderSuggestions = function (value) {
            return true;
        };
        // Teach Autosuggest how to calculate suggestions for any given input value.
        _this.getSuggestions = function (value) {
            var inputValue = value.trim().toLowerCase();
            var inputLength = inputValue.length;
            var specsToDisplay = inputLength === 0
                ? _this.props.filterSuggestions
                : _this.props.filterSuggestions.filter(function (specValue) { return specValue.toLowerCase().slice(0, inputLength) === inputValue; });
            // limit results to display since rendering all elements is expensive
            // add clear on beggining of results
            return [CLEAR_SELECTION].concat(specsToDisplay.slice(0, 100));
        };
        _this.onChange = function (event, _a) {
            var newValue = _a.newValue, method = _a.method;
            _this.setState({
                value: _this.emptyWhenSelectedValueIsClear(newValue),
            });
        };
        _this.onBlur = function (event, _a) {
            var highlightedSuggestion = _a.highlightedSuggestion;
            _this.props.onChangeFromSpecTable(_this.emptyWhenSelectedValueIsClear(event.target.value));
        };
        _this.onKeyDown = function (event) {
            if (event.key === 'Enter') {
                _this.props.onChangeFromSpecTable(_this.emptyWhenSelectedValueIsClear(event.target.value));
            }
        };
        // Autosuggest will call this function every time you need to update suggestions.
        // You already implemented this logic above, so just use it.
        _this.onSuggestionsFetchRequested = function (_a) {
            var value = _a.value;
            _this.setState({
                suggestions: _this.getSuggestions(value),
            });
        };
        // Autosuggest will call this function every time you need to clear suggestions.
        _this.onSuggestionsClearRequested = function () {
            _this.setState({
                suggestions: [],
            });
        };
        _this.renderSuggestionsContainer = function (_a) {
            var containerProps = _a.containerProps, children = _a.children;
            var ref = containerProps.ref, restContainerProps = __rest(containerProps, ["ref"]);
            var callRef = function (isolatedScroll) {
                if (isolatedScroll !== null) {
                    ref(isolatedScroll.component);
                }
            };
            return (react_1.default.createElement(react_isolated_scroll_1.default, __assign({ ref: callRef }, restContainerProps), children));
        };
        // Clearing does not trigger this, use componentDidUpate instead
        _this.onSuggestionSelected = function (event, _a) {
            var suggestion = _a.suggestion, suggestionValue = _a.suggestionValue, suggestionIndex = _a.suggestionIndex, sectionIndex = _a.sectionIndex, method = _a.method;
            console.log('onsuggestionseleced: ', method);
            _this.props.onChangeFromSpecTable(_this.emptyWhenSelectedValueIsClear(suggestionValue));
        };
        _this.state = {
            error: null,
            isLoaded: false,
            specValues: props.filterSuggestions,
            value: '',
            suggestions: [],
        };
        return _this;
    }
    SellerGroupModelListFilter.prototype.emptyWhenSelectedValueIsClear = function (newValue) {
        return CLEAR_SELECTION === newValue ? '' : newValue;
    };
    SellerGroupModelListFilter.prototype.render = function () {
        var _a = this.state, value = _a.value, suggestions = _a.suggestions;
        // Autosuggest will pass through all these props to the input.
        var inputProps = {
            placeholder: '',
            value: value,
            onChange: this.onChange,
            onBlur: this.onBlur,
            onKeyDown: this.onKeyDown,
        };
        return (react_1.default.createElement("div", { className: "filterIcon" },
            react_1.default.createElement(react_autosuggest_1.default, { suggestions: suggestions, onSuggestionsFetchRequested: this.onSuggestionsFetchRequested, onSuggestionsClearRequested: this.onSuggestionsClearRequested, onSuggestionSelected: this.onSuggestionSelected, getSuggestionValue: getSuggestionValue, renderSuggestion: renderSuggestion, inputProps: inputProps, shouldRenderSuggestions: this.shouldRenderSuggestions, renderSuggestionsContainer: this.renderSuggestionsContainer }),
            react_1.default.createElement("i", { className: "fa fa-filter" })));
    };
    SellerGroupModelListFilter.propTypes = {
        filterSuggestions: prop_types_1.default.any.isRequired,
        specId: prop_types_1.default.any.isRequired,
        onChangeFromSpecTable: prop_types_1.default.any.isRequired,
    };
    return SellerGroupModelListFilter;
}(react_1.default.Component));
exports.default = SellerGroupModelListFilter;
